export enum TipoConsumibleType{
    BEBIDA='bebida',
    COMIDA='comida'

}